import { baseApiClient as api } from "../baseService";
export const addTagTypes = [
  "postgrid_attachments",
  "postgrid_cheques",
  "postgrid_contacts",
  "postgrid_events",
  "postgrid_letters",
  "postgrid_mailables",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postgridAttachmentsList: build.query<
        PostgridAttachmentsListApiResponse,
        PostgridAttachmentsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/`,
          params: {
            chequeId: queryArg.chequeId,
            letterId: queryArg.letterId,
          },
        }),
        providesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsRetrieve: build.query<
        PostgridAttachmentsRetrieveApiResponse,
        PostgridAttachmentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/${queryArg.id}/`,
        }),
        providesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsDestroy: build.mutation<
        PostgridAttachmentsDestroyApiResponse,
        PostgridAttachmentsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsAddToCheque: build.mutation<
        PostgridAttachmentsAddToChequeApiResponse,
        PostgridAttachmentsAddToChequeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/add_to_cheque/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsAddToLetter: build.mutation<
        PostgridAttachmentsAddToLetterApiResponse,
        PostgridAttachmentsAddToLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/add_to_letter/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsClearChequeAttachments: build.mutation<
        PostgridAttachmentsClearChequeAttachmentsApiResponse,
        PostgridAttachmentsClearChequeAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/clear_cheque_attachments/`,
          method: "DELETE",
          params: {
            cheque_id: queryArg.chequeId,
          },
        }),
        invalidatesTags: ["postgrid_attachments"],
      }),
      postgridAttachmentsClearLetterAttachments: build.mutation<
        PostgridAttachmentsClearLetterAttachmentsApiResponse,
        PostgridAttachmentsClearLetterAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/attachments/clear_letter_attachments/`,
          method: "DELETE",
          params: {
            letter_id: queryArg.letterId,
          },
        }),
        invalidatesTags: ["postgrid_attachments"],
      }),
      postgridChequesList: build.query<
        PostgridChequesListApiResponse,
        PostgridChequesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/`,
          params: {
            matterId: queryArg.matterId,
          },
        }),
        providesTags: ["postgrid_cheques"],
      }),
      postgridChequesCreate: build.mutation<
        PostgridChequesCreateApiResponse,
        PostgridChequesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/`,
          method: "POST",
          body: queryArg.createPostgridCheque,
        }),
        invalidatesTags: ["postgrid_cheques"],
      }),
      postgridChequesRetrieve: build.query<
        PostgridChequesRetrieveApiResponse,
        PostgridChequesRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/api/postgrid/cheques/${queryArg.id}/` }),
        providesTags: ["postgrid_cheques"],
      }),
      postgridChequesCancel: build.mutation<
        PostgridChequesCancelApiResponse,
        PostgridChequesCancelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/${queryArg.id}/cancel/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_cheques"],
      }),
      postgridChequesDetailed: build.query<
        PostgridChequesDetailedApiResponse,
        PostgridChequesDetailedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/${queryArg.id}/detailed/`,
        }),
        providesTags: ["postgrid_cheques"],
      }),
      postgridChequesProgressTest: build.mutation<
        PostgridChequesProgressTestApiResponse,
        PostgridChequesProgressTestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/${queryArg.id}/progress_test/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_cheques"],
      }),
      postgridChequesRetrySend: build.mutation<
        PostgridChequesRetrySendApiResponse,
        PostgridChequesRetrySendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/cheques/${queryArg.id}/retry_send/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_cheques"],
      }),
      postgridChequesUnsynced: build.query<
        PostgridChequesUnsyncedApiResponse,
        PostgridChequesUnsyncedApiArg
      >({
        query: () => ({ url: `/api/postgrid/cheques/unsynced/` }),
        providesTags: ["postgrid_cheques"],
      }),
      postgridContactsList: build.query<
        PostgridContactsListApiResponse,
        PostgridContactsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/`,
          params: {
            is_active: queryArg.isActive,
            limit: queryArg.limit,
            matterId: queryArg.matterId,
            offset: queryArg.offset,
            police_channel_id: queryArg.policeChannelId,
            q: queryArg.q,
          },
        }),
        providesTags: ["postgrid_contacts"],
      }),
      postgridContactsCreate: build.mutation<
        PostgridContactsCreateApiResponse,
        PostgridContactsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/`,
          method: "POST",
          body: queryArg.createPostgridContact,
          params: {
            skip_verification: queryArg.skipVerification,
          },
        }),
        invalidatesTags: ["postgrid_contacts"],
      }),
      postgridContactsRetrieve: build.query<
        PostgridContactsRetrieveApiResponse,
        PostgridContactsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/${queryArg.id}/`,
        }),
        providesTags: ["postgrid_contacts"],
      }),
      postgridContactsUpdate: build.mutation<
        PostgridContactsUpdateApiResponse,
        PostgridContactsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updatePostgridContact,
        }),
        invalidatesTags: ["postgrid_contacts"],
      }),
      postgridContactsDestroy: build.mutation<
        PostgridContactsDestroyApiResponse,
        PostgridContactsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["postgrid_contacts"],
      }),
      postgridContactsRetrySync: build.mutation<
        PostgridContactsRetrySyncApiResponse,
        PostgridContactsRetrySyncApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/${queryArg.id}/retry_sync/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_contacts"],
      }),
      postgridContactsByPoliceChannel: build.query<
        PostgridContactsByPoliceChannelApiResponse,
        PostgridContactsByPoliceChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/contacts/by_police_channel/`,
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        providesTags: ["postgrid_contacts"],
      }),
      postgridContactsUnsynced: build.query<
        PostgridContactsUnsyncedApiResponse,
        PostgridContactsUnsyncedApiArg
      >({
        query: () => ({ url: `/api/postgrid/contacts/unsynced/` }),
        providesTags: ["postgrid_contacts"],
      }),
      postgridEventsList: build.query<
        PostgridEventsListApiResponse,
        PostgridEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/events/`,
          params: {
            chequeId: queryArg.chequeId,
            letterId: queryArg.letterId,
            objectId: queryArg.objectId,
          },
        }),
        providesTags: ["postgrid_events"],
      }),
      postgridEventsRetrieve: build.query<
        PostgridEventsRetrieveApiResponse,
        PostgridEventsRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/api/postgrid/events/${queryArg.id}/` }),
        providesTags: ["postgrid_events"],
      }),
      postgridLettersList: build.query<
        PostgridLettersListApiResponse,
        PostgridLettersListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/`,
          params: {
            matterId: queryArg.matterId,
          },
        }),
        providesTags: ["postgrid_letters"],
      }),
      postgridLettersCreate: build.mutation<
        PostgridLettersCreateApiResponse,
        PostgridLettersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/`,
          method: "POST",
          body: queryArg.createPostgridLetter,
        }),
        invalidatesTags: ["postgrid_letters"],
      }),
      postgridLettersRetrieve: build.query<
        PostgridLettersRetrieveApiResponse,
        PostgridLettersRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/api/postgrid/letters/${queryArg.id}/` }),
        providesTags: ["postgrid_letters"],
      }),
      postgridLettersCancel: build.mutation<
        PostgridLettersCancelApiResponse,
        PostgridLettersCancelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/${queryArg.id}/cancel/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_letters"],
      }),
      postgridLettersDetailed: build.query<
        PostgridLettersDetailedApiResponse,
        PostgridLettersDetailedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/${queryArg.id}/detailed/`,
        }),
        providesTags: ["postgrid_letters"],
      }),
      postgridLettersProgressTest: build.mutation<
        PostgridLettersProgressTestApiResponse,
        PostgridLettersProgressTestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/${queryArg.id}/progress_test/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_letters"],
      }),
      postgridLettersRetrySend: build.mutation<
        PostgridLettersRetrySendApiResponse,
        PostgridLettersRetrySendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/${queryArg.id}/retry_send/`,
          method: "POST",
        }),
        invalidatesTags: ["postgrid_letters"],
      }),
      postgridLettersExtractRecipient: build.mutation<
        PostgridLettersExtractRecipientApiResponse,
        PostgridLettersExtractRecipientApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/letters/extract-recipient/`,
          method: "POST",
          body: queryArg.extractRecipientRequest,
        }),
        invalidatesTags: ["postgrid_letters"],
      }),
      postgridLettersUnsynced: build.query<
        PostgridLettersUnsyncedApiResponse,
        PostgridLettersUnsyncedApiArg
      >({
        query: () => ({ url: `/api/postgrid/letters/unsynced/` }),
        providesTags: ["postgrid_letters"],
      }),
      postgridMailablesList: build.query<
        PostgridMailablesListApiResponse,
        PostgridMailablesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/postgrid/mailables/`,
          params: {
            created_after: queryArg.createdAfter,
            created_before: queryArg.createdBefore,
            limit: queryArg.limit,
            mailable_type: queryArg.mailableType,
            matterId: queryArg.matterId,
            offset: queryArg.offset,
            ordering: queryArg.ordering,
            q: queryArg.q,
            status: queryArg.status,
          },
        }),
        providesTags: ["postgrid_mailables"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type PostgridAttachmentsListApiResponse =
  /** status 200  */ ReadPostgridAttachment[];
export type PostgridAttachmentsListApiArg = {
  /** Filter attachments by cheque ID */
  chequeId?: string;
  /** Filter attachments by letter ID */
  letterId?: string;
};
export type PostgridAttachmentsRetrieveApiResponse =
  /** status 200  */ ReadPostgridAttachment;
export type PostgridAttachmentsRetrieveApiArg = {
  id: string;
};
export type PostgridAttachmentsDestroyApiResponse = /** status 200  */ {
  deleted?: boolean;
};
export type PostgridAttachmentsDestroyApiArg = {
  id: string;
};
export type PostgridAttachmentsAddToChequeApiResponse =
  /** status 201  */ ReadPostgridAttachment;
export type PostgridAttachmentsAddToChequeApiArg = {
  body: Blob;
};
export type PostgridAttachmentsAddToLetterApiResponse =
  /** status 201  */ ReadPostgridAttachment;
export type PostgridAttachmentsAddToLetterApiArg = {
  body: Blob;
};
export type PostgridAttachmentsClearChequeAttachmentsApiResponse =
  /** status 200  */ {
    cleared?: boolean;
  };
export type PostgridAttachmentsClearChequeAttachmentsApiArg = {
  /** UUID of the cheque */
  chequeId: string;
};
export type PostgridAttachmentsClearLetterAttachmentsApiResponse =
  /** status 200  */ {
    cleared?: boolean;
  };
export type PostgridAttachmentsClearLetterAttachmentsApiArg = {
  /** UUID of the letter */
  letterId: string;
};
export type PostgridChequesListApiResponse =
  /** status 200  */ ReadDetailedPostgridCheque[];
export type PostgridChequesListApiArg = {
  /** Filter cheques by matter ID */
  matterId?: string;
};
export type PostgridChequesCreateApiResponse =
  /** status 201  */ ReadPostgridCheque;
export type PostgridChequesCreateApiArg = {
  createPostgridCheque: CreatePostgridCheque;
};
export type PostgridChequesRetrieveApiResponse =
  /** status 200  */ ReadPostgridCheque;
export type PostgridChequesRetrieveApiArg = {
  id: string;
};
export type PostgridChequesCancelApiResponse =
  /** status 200  */ ReadPostgridCheque;
export type PostgridChequesCancelApiArg = {
  id: string;
};
export type PostgridChequesDetailedApiResponse =
  /** status 200  */ ReadDetailedPostgridCheque;
export type PostgridChequesDetailedApiArg = {
  id: string;
};
export type PostgridChequesProgressTestApiResponse =
  /** status 200  */ ReadPostgridCheque;
export type PostgridChequesProgressTestApiArg = {
  id: string;
};
export type PostgridChequesRetrySendApiResponse =
  /** status 200  */ ReadPostgridCheque;
export type PostgridChequesRetrySendApiArg = {
  id: string;
};
export type PostgridChequesUnsyncedApiResponse =
  /** status 200  */ ReadDetailedPostgridCheque;
export type PostgridChequesUnsyncedApiArg = void;
export type PostgridContactsListApiResponse =
  /** status 200  */ PaginatedReadPostgridContactList;
export type PostgridContactsListApiArg = {
  /** Filter by active status */
  isActive?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  /** Filter contacts by matter ID */
  matterId?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Filter by associated police records channel */
  policeChannelId?: string;
  /** Search query to filter by name or company */
  q?: string;
};
export type PostgridContactsCreateApiResponse =
  /** status 201  */ ReadPostgridContact;
export type PostgridContactsCreateApiArg = {
  /** Skip PostGrid address verification and preserve user's original address */
  skipVerification?: boolean;
  createPostgridContact: CreatePostgridContact;
};
export type PostgridContactsRetrieveApiResponse =
  /** status 200  */ ReadPostgridContact;
export type PostgridContactsRetrieveApiArg = {
  id: string;
};
export type PostgridContactsUpdateApiResponse =
  /** status 200  */ ReadPostgridContact;
export type PostgridContactsUpdateApiArg = {
  id: string;
  updatePostgridContact: UpdatePostgridContact;
};
export type PostgridContactsDestroyApiResponse = /** status 200  */ {
  deleted?: boolean;
};
export type PostgridContactsDestroyApiArg = {
  id: string;
};
export type PostgridContactsRetrySyncApiResponse =
  /** status 200  */ ReadPostgridContact;
export type PostgridContactsRetrySyncApiArg = {
  id: string;
};
export type PostgridContactsByPoliceChannelApiResponse =
  /** status 200  */ ReadPostgridContact;
export type PostgridContactsByPoliceChannelApiArg = {
  /** Police records channel ID */
  channelId: string;
};
export type PostgridContactsUnsyncedApiResponse =
  /** status 200  */ ReadPostgridContact;
export type PostgridContactsUnsyncedApiArg = void;
export type PostgridEventsListApiResponse =
  /** status 200  */ ReadPostgridEvent[];
export type PostgridEventsListApiArg = {
  /** Filter events by cheque ID specifically */
  chequeId?: string;
  /** Filter events by letter ID specifically */
  letterId?: string;
  /** Filter events by related object ID (cheque or letter) */
  objectId?: string;
};
export type PostgridEventsRetrieveApiResponse = unknown;
export type PostgridEventsRetrieveApiArg = {
  id: string;
};
export type PostgridLettersListApiResponse =
  /** status 200  */ ReadDetailedPostgridLetter[];
export type PostgridLettersListApiArg = {
  /** Filter letters by matter ID */
  matterId?: string;
};
export type PostgridLettersCreateApiResponse =
  /** status 201  */ ReadPostgridLetter;
export type PostgridLettersCreateApiArg = {
  createPostgridLetter: CreatePostgridLetter;
};
export type PostgridLettersRetrieveApiResponse =
  /** status 200  */ ReadPostgridLetter;
export type PostgridLettersRetrieveApiArg = {
  id: string;
};
export type PostgridLettersCancelApiResponse =
  /** status 200  */ ReadPostgridLetter;
export type PostgridLettersCancelApiArg = {
  id: string;
};
export type PostgridLettersDetailedApiResponse =
  /** status 200  */ ReadDetailedPostgridLetter;
export type PostgridLettersDetailedApiArg = {
  id: string;
};
export type PostgridLettersProgressTestApiResponse =
  /** status 200  */ ReadPostgridLetter;
export type PostgridLettersProgressTestApiArg = {
  id: string;
};
export type PostgridLettersRetrySendApiResponse =
  /** status 200  */ ReadPostgridLetter;
export type PostgridLettersRetrySendApiArg = {
  id: string;
};
export type PostgridLettersExtractRecipientApiResponse =
  /** status 200  */ ExtractRecipientResponse;
export type PostgridLettersExtractRecipientApiArg = {
  extractRecipientRequest: ExtractRecipientRequest;
};
export type PostgridLettersUnsyncedApiResponse =
  /** status 200  */ ReadDetailedPostgridLetter;
export type PostgridLettersUnsyncedApiArg = void;
export type PostgridMailablesListApiResponse =
  /** status 200 Paginated list of mailable items (cheques and letters) */ {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: (
      | ({
          mailable_type: "cheque";
        } & ChequeMailableItem)
      | ({
          mailable_type: "letter";
        } & LetterMailableItem)
    )[];
  };
export type PostgridMailablesListApiArg = {
  /** Filter mailables created on or after this datetime (ISO 8601). */
  createdAfter?: string;
  /** Filter mailables created on or before this datetime (ISO 8601). */
  createdBefore?: string;
  /** Maximum number of items to return (default 100, max 500) */
  limit?: number;
  /** Filter by type: 'cheque' or 'letter'. If omitted, returns both. */
  mailableType?: string;
  /** UUID of the Matter to filter mailables. If omitted, returns all mailables. */
  matterId?: string;
  /** Number of items to skip for pagination (default 0) */
  offset?: number;
  /** Field to sort by. Use '-' prefix for descending. Valid fields: date_sent, created_at, expected_delivery_date. Default: -created_at (newest first). */
  ordering?: string;
  /** Search query to filter by contact name or company. Uses full-text search with prefix matching. */
  q?: string;
  /** Filter by status. Can be a single status or comma-separated list. */
  status?: string;
};
export type BlobSchema = {
  id: string | string;
  name: string;
  original_filename: string | null;
  collection_id: string | string;
  collection_name: string;
  file_hash: string;
  file_size: number;
  file_extension: string | null;
  file_mime_type: string | null;
  download_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type ReadPostgridAttachment = {
  id: string | string;
  /** Primary key of the underlying Blob object */
  blob: BlobSchema;
  cheque_id?: (string | string) | null;
  letter_id?: (string | string) | null;
  description?: string | null;
  /** ID of the associated artifact, if any */
  artifact_id?: (string | string) | null;
};
export type PostGridChequeType = "standard" | "voucher";
export type PostGridChequeSize = "us_letter" | "us_legal";
export type PostGridMailingClass =
  | "first_class"
  | "standard_class"
  | "express"
  | "certified"
  | "certified_return_receipt"
  | "registered"
  | "usps_first_class"
  | "usps_standard_class"
  | "usps_eddm"
  | "usps_express_2_day"
  | "usps_express_3_day"
  | "usps_first_class_certified"
  | "usps_first_class_certified_return_receipt"
  | "usps_first_class_registered"
  | "usps_express_3_day_signature_confirmation"
  | "usps_express_3_day_certified"
  | "usps_express_3_day_certified_return_receipt"
  | "ca_post_lettermail"
  | "ca_post_personalized"
  | "ca_post_neighbourhood_mail"
  | "ca_post_registered"
  | "ca_post_expedited_with_signature"
  | "ca_post_expedited"
  | "ca_post_xpresspost_with_signature"
  | "ca_post_xpresspost"
  | "royal_mail_first_class"
  | "royal_mail_standard_class"
  | "au_post_regular"
  | "au_post_second_class"
  | "ups_express_overnight"
  | "ups_express_2_day"
  | "ups_express_3_day"
  | "ups_express_3_day_signature_confirmation"
  | "ups_express_3_day_adult_signature_confirmation";
export type PostGridObjectStatus =
  | "creating"
  | "ready"
  | "printing"
  | "in_transit"
  | "in_local_area"
  | "processed_for_delivery"
  | "processed"
  | "delivered"
  | "re-routed"
  | "returned_to_sender"
  | "cancelled"
  | "completed"
  | "failed";
export type CarrierTrackingLocation = {
  city?: string | null;
  provinceOrState?: string | null;
  countryCode?: string | null;
  postalOrZip?: string | null;
};
export type CarrierTrackingUpdate = {
  message: string;
  status: string;
  createdAt: string;
  source: string;
  trackingLocation?: CarrierTrackingLocation;
};
export type CarrierTrackingData = {
  status: string;
  statusDetail?: string | null;
  estDeliveryDate?: string | null;
  signedBy?: string | null;
  carrier: string;
  trackingUpdates?: CarrierTrackingUpdate[];
};
export type ReadPostgridContact = {
  address_line1: string;
  city: string;
  province_or_state: string;
  postal_or_zip: string;
  country: string;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
  address_line2?: string | null;
  email?: string | null;
  phone_number?: string | null;
  notes?: string | null;
  is_verified?: boolean;
  is_active?: boolean;
  is_global_sender?: boolean;
  live?: boolean;
  id: string | string;
  postgrid_id: string;
  created_at?: string | null;
  modified_at?: string | null;
};
export type PostGridEventType =
  | "letter.created"
  | "letter.updated"
  | "postcard.created"
  | "postcard.updated"
  | "self_mailer.created"
  | "self_mailer.updated"
  | "cheque.created"
  | "cheque.updated"
  | "box.created"
  | "box.updated"
  | "return_envelope_order.created"
  | "return_envelope_order.updated"
  | "tracker.visited"
  | "campaign.created"
  | "campaign.updated"
  | "general.error"
  | "cheque.ready"
  | "letter.ready"
  | "processing.failed";
export type PostGridEventStatus =
  | "pending"
  | "processing"
  | "processed"
  | "failed"
  | "retrying";
export type PostGridBankAccountType = "chequing" | "savings";
export type BankAccountSchema = {
  id: string;
  object?: "bank_account";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  bankName?: string | null;
  accountType?: PostGridBankAccountType;
  routingNumber?: string | null;
  lastFour?: string | null;
  verified?: boolean | null;
};
export type ContactStub = {
  id: string;
  object: string;
  addressLine1: string;
  city: string;
  postalOrZip: string;
  countryCode: string;
  provinceOrState?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  jobTitle?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  addressLine2?: string | null;
  addressStatus?: string | null;
};
export type PostGridDeliverySpeed = "standard" | "express";
export type PostGridExtraService =
  | "certified"
  | "certified_return_receipt"
  | "registered";
export type PostGridImbStatus =
  | "entered_mail_stream"
  | "out_for_delivery"
  | "returned_to_sender";
export type CarrierTrackingData2 = {
  status: string;
  statusDetail?: string | null;
  estDeliveryDate?: string | null;
  signedBy?: string | null;
  carrier: string;
  trackingUpdates?: CarrierTrackingUpdate[];
};
export type ChequeSchema = {
  id: string;
  object?: "cheque";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  status: PostGridObjectStatus;
  to: ContactStub;
  from: ContactStub;
  deliverySpeed?: PostGridDeliverySpeed;
  mailingClass?: PostGridMailingClass;
  extraService?: PostGridExtraService;
  imbStatus?: PostGridImbStatus;
  imbDate?: (string | string) | null;
  imbZipCode?: string | null;
  trackingNumber?: string | null;
  carrierTracking?: CarrierTrackingData2;
  url?: string | null;
  expectedDeliveryDate?: string | null;
  returnEnvelope?: string | null;
  /** Date the mailable was sent to the carrier */
  sendDate?: string | null;
  amount: number;
  memo?: string | null;
  number?: number | null;
  bankAccount: string;
  chequeType?: PostGridChequeType;
  size?: PostGridChequeSize;
};
export type AddressSchema = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  province_or_state?: string | null;
  postal_or_zip?: string | null;
  country_code?: string | null;
};
export type AddressChangeObjectSchema = {
  processed_on?: string | null;
  move_year_month?: string | null;
  old_address?: AddressSchema;
};
export type ContactSchema = {
  id: string;
  object?: "contact";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  addressLine1: string;
  city: string;
  postalOrZip: string;
  countryCode: string;
  provinceOrState?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  jobTitle?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  addressLine2?: string | null;
  addressStatus?: string | null;
  addressChange?: AddressChangeObjectSchema;
};
export type PostGridLetterSize = "us_letter" | "us_legal" | "a4";
export type LetterSchema = {
  id: string;
  object?: "letter";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  status: PostGridObjectStatus;
  to: ContactStub;
  from: ContactStub;
  deliverySpeed?: PostGridDeliverySpeed;
  mailingClass?: PostGridMailingClass;
  extraService?: PostGridExtraService;
  imbStatus?: PostGridImbStatus;
  imbDate?: (string | string) | null;
  imbZipCode?: string | null;
  trackingNumber?: string | null;
  carrierTracking?: CarrierTrackingData2;
  url?: string | null;
  expectedDeliveryDate?: string | null;
  returnEnvelope?: string | null;
  /** Date the mailable was sent to the carrier */
  sendDate?: string | null;
  size: PostGridLetterSize;
  pageCount?: number | null;
};
export type ReturnEnvelopeSchema = {
  id: string;
  object?: "return_envelope";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  available: number;
  to: ContactStub;
};
export type ReturnEnvelopeOrderStatus = "placed" | "filled" | "cancelled";
export type ReturnEnvelopeOrderSchema = {
  id: string;
  object?: "return_envelope_order";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  quantityOrdered: number;
  returnEnvelope: string | ReturnEnvelopeSchema;
  status: ReturnEnvelopeOrderStatus;
};
export type WebhookSchema = {
  id: string;
  object?: "webhook";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  url: string;
  enabledEvents: PostGridEventType[];
  liveMode?: boolean | null;
};
export type PostgridEventSchema = {
  id: string;
  object?: "event";
  live: boolean;
  createdAt: string;
  updatedAt?: string | null;
  metadata?: {
    [key: string]: any;
  };
  type: PostGridEventType;
  data:
    | ({
        object: "bank_account";
      } & BankAccountSchema)
    | ({
        object: "cheque";
      } & ChequeSchema)
    | ({
        object: "contact";
      } & ContactSchema)
    | ({
        object: "letter";
      } & LetterSchema)
    | ({
        object: "return_envelope";
      } & ReturnEnvelopeSchema)
    | ({
        object: "return_envelope_order";
      } & ReturnEnvelopeOrderSchema)
    | ({
        object: "webhook";
      } & WebhookSchema);
};
export type ReadPostgridEvent = {
  id: string | string;
  live: boolean;
  created_at: string;
  modified_at: string;
  processed_at?: string | null;
  postgrid_id: string;
  event_type: PostGridEventType;
  occurred_at: string;
  processing_status: PostGridEventStatus;
  related_object_type?: string | null;
  related_object_id?: (string | string) | null;
  cheque_id?: (string | string) | null;
  processing_error?: string | null;
  letter_id?: (string | string) | null;
  event_data:
    | PostgridEventSchema
    | {
        [key: string]: any;
      };
};
export type ReadDetailedPostgridCheque = {
  /** Cheque amount (min $0.01, max enforced by domain) */
  amount: string;
  memo?: string | null;
  number?: number | null;
  date_cleared?: string | null;
  cheque_type?: PostGridChequeType;
  cheque_size?: PostGridChequeSize;
  mailing_class?: PostGridMailingClass;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  bank_account_id: (string | string) | null;
  live?: boolean;
  final_pdf_url?: string | null;
  id: string | string;
  matter_id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
  to_contact: ReadPostgridContact;
  from_contact: ReadPostgridContact;
  events?: ReadPostgridEvent[];
  attachments?: ReadPostgridAttachment[];
};
export type CarrierTrackingData3 = {
  status: string;
  statusDetail?: string | null;
  estDeliveryDate?: string | null;
  signedBy?: string | null;
  carrier: string;
  trackingUpdates?: CarrierTrackingUpdate[];
};
export type ReadPostgridCheque = {
  /** Cheque amount (min $0.01, max enforced by domain) */
  amount: string;
  memo?: string | null;
  number?: number | null;
  date_cleared?: string | null;
  cheque_type?: PostGridChequeType;
  cheque_size?: PostGridChequeSize;
  mailing_class?: PostGridMailingClass;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  bank_account_id: (string | string) | null;
  live?: boolean;
  final_pdf_url?: string | null;
  id: string | string;
  matter_id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData3;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
};
export type CreatePostgridCheque = {
  /** Cheque amount (min $0.01, max enforced by domain) */
  amount: string;
  memo?: string | null;
  number?: number | null;
  date_cleared?: string | null;
  cheque_type?: PostGridChequeType;
  cheque_size?: PostGridChequeSize;
  mailing_class?: PostGridMailingClass;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  bank_account_id: (string | string) | null;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  idempotency_key?: string | null;
  blob_ids?: (string | string)[] | null;
};
export type PaginatedReadPostgridContactList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ReadPostgridContact[];
};
export type CreatePostgridContact = {
  address_line1: string;
  city: string;
  province_or_state: string;
  postal_or_zip: string;
  country: string;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
  address_line2?: string | null;
  email?: string | null;
  phone_number?: string | null;
  notes?: string | null;
  is_verified?: boolean;
  is_active?: boolean;
  is_global_sender?: boolean;
  live?: boolean;
};
export type UpdatePostgridContact = {
  address_line1?: string | null;
  city?: string | null;
  province_or_state?: string | null;
  postal_or_zip?: string | null;
  country?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
  address_line2?: string | null;
  email?: string | null;
  phone_number?: string | null;
  notes?: string | null;
  is_verified?: boolean;
  is_active?: boolean;
  is_global_sender?: boolean;
  live?: boolean;
};
export type PostGridAddressPlacement =
  | "top_first_page"
  | "top_of_page"
  | "insert_blank_page";
export type ReadPostgridReturnEnvelope = {
  /** Name/description of this return envelope */
  name: string;
  /** Return address line 1 */
  return_address_line1: string;
  /** Return address line 2 */
  return_address_line2?: string | null;
  /** Return address city */
  return_city: string;
  /** Return address province or state */
  return_province_or_state: string;
  /** Return address postal or zip code */
  return_postal_or_zip: string;
  /** Return address country code */
  return_country?: string;
  /** URL to envelope template PDF */
  envelope_template_url?: string | null;
  is_global_default?: boolean;
  notes?: string | null;
  live?: boolean;
  id: string | string;
  postgrid_id: string;
  created_at?: string | null;
  modified_at?: string | null;
};
export type ReadDetailedPostgridLetter = {
  subject?: string | null;
  content?: string | null;
  letter_size?: PostGridLetterSize;
  address_placement?: PostGridAddressPlacement;
  mailing_class?: PostGridMailingClass;
  color?: boolean;
  double_sided?: boolean;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
  to_contact: ReadPostgridContact;
  from_contact: ReadPostgridContact;
  events?: ReadPostgridEvent[];
  attachments?: ReadPostgridAttachment[];
  return_envelope?: ReadPostgridReturnEnvelope;
};
export type ReadPostgridLetter = {
  subject?: string | null;
  content?: string | null;
  letter_size?: PostGridLetterSize;
  address_placement?: PostGridAddressPlacement;
  mailing_class?: PostGridMailingClass;
  color?: boolean;
  double_sided?: boolean;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData3;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
};
export type CreatePostgridLetter = {
  subject?: string | null;
  content?: string | null;
  letter_size?: PostGridLetterSize;
  address_placement?: PostGridAddressPlacement;
  mailing_class?: PostGridMailingClass;
  color?: boolean;
  double_sided?: boolean;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  idempotency_key?: string | null;
  blob_ids?: (string | string)[] | null;
  pdf_bytes?: Blob | null;
};
export type ExtractedRecipientInfo = {
  /** First name of the recipient */
  first_name?: string | null;
  /** Last name of the recipient */
  last_name?: string | null;
  /** Company or organization name */
  company_name?: string | null;
  /** Street address line 1 */
  address_line1?: string | null;
  /** Street address line 2 (apt, suite, etc.) */
  address_line2?: string | null;
  /** City */
  city?: string | null;
  /** State or province */
  province_or_state?: string | null;
  /** Postal or ZIP code */
  postal_or_zip?: string | null;
  /** Country (defaults to US if not specified) */
  country?: string | null;
  /** Confidence score of the extraction (0.0 to 1.0) */
  confidence?: number;
  /** Notes about the extraction process or any issues encountered */
  extraction_notes?: string | null;
  /** Names of fields that were successfully extracted (non-null values) */
  extracted_fields?: string[];
};
export type ExtractRecipientResponse = {
  /** Whether the extraction was successful */
  success: boolean;
  /** Extracted recipient information */
  recipient?: ExtractedRecipientInfo;
  /** Error message if extraction failed */
  error?: string | null;
};
export type ExtractRecipientRequest = {
  /** The ID of the blob (document) to extract recipient info from */
  blob_id: string;
};
export type ChequeMailableItem = {
  /** Cheque amount (min $0.01, max enforced by domain) */
  amount: string;
  memo?: string | null;
  number?: number | null;
  date_cleared?: string | null;
  cheque_type?: PostGridChequeType;
  cheque_size?: PostGridChequeSize;
  mailing_class?: PostGridMailingClass;
  to_contact_id: string | string;
  from_contact_id?: string | string | null;
  return_envelope_id?: string | string | null;
  use_return_envelope?: boolean;
  bank_account_id: string | string | null;
  live?: boolean;
  final_pdf_url?: string | null;
  id: string | string;
  matter_id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData3 | null;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
  mailable_type?: "cheque";
  /** Display name of the recipient contact (denormalized for list views) */
  to_contact_name?: string | null;
};
export type LetterMailableItem = {
  subject?: string | null;
  content?: string | null;
  letter_size?: PostGridLetterSize;
  address_placement?: PostGridAddressPlacement;
  mailing_class?: PostGridMailingClass;
  color?: boolean;
  double_sided?: boolean;
  to_contact_id: string | string;
  from_contact_id?: string | string | null;
  return_envelope_id?: string | string | null;
  use_return_envelope?: boolean;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData3 | null;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
  mailable_type?: "letter";
  /** Display name of the recipient contact (denormalized for list views) */
  to_contact_name?: string | null;
};
export const {
  usePostgridAttachmentsListQuery,
  usePostgridAttachmentsRetrieveQuery,
  usePostgridAttachmentsDestroyMutation,
  usePostgridAttachmentsAddToChequeMutation,
  usePostgridAttachmentsAddToLetterMutation,
  usePostgridAttachmentsClearChequeAttachmentsMutation,
  usePostgridAttachmentsClearLetterAttachmentsMutation,
  usePostgridChequesListQuery,
  usePostgridChequesCreateMutation,
  usePostgridChequesRetrieveQuery,
  usePostgridChequesCancelMutation,
  usePostgridChequesDetailedQuery,
  usePostgridChequesProgressTestMutation,
  usePostgridChequesRetrySendMutation,
  usePostgridChequesUnsyncedQuery,
  usePostgridContactsListQuery,
  usePostgridContactsCreateMutation,
  usePostgridContactsRetrieveQuery,
  usePostgridContactsUpdateMutation,
  usePostgridContactsDestroyMutation,
  usePostgridContactsRetrySyncMutation,
  usePostgridContactsByPoliceChannelQuery,
  usePostgridContactsUnsyncedQuery,
  usePostgridEventsListQuery,
  usePostgridEventsRetrieveQuery,
  usePostgridLettersListQuery,
  usePostgridLettersCreateMutation,
  usePostgridLettersRetrieveQuery,
  usePostgridLettersCancelMutation,
  usePostgridLettersDetailedQuery,
  usePostgridLettersProgressTestMutation,
  usePostgridLettersRetrySendMutation,
  usePostgridLettersExtractRecipientMutation,
  usePostgridLettersUnsyncedQuery,
  usePostgridMailablesListQuery,
} = injectedRtkApi;
